export const API_BASE =
  process.env.REACT_APP_API_URL || 'https://server.agrotraciserp.com';

export const API_URL = `${API_BASE}/api`;
